module.exports = __webpack_public_path__ + "static/media/logoWhite.fb1af321.svg";